module.exports = __webpack_public_path__ + "static/img/img_ser_wx.86fa2a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_ser_wx.png
// module id = dYtW
// module chunks = 1